import styles from "./GroupsFilterButton.module.css";
const GroupsFilterButton: React.FC<{
  label: string;
  onClick?: () => void;
  icon: React.ReactNode;
  iconBgColor: string;
  borderColor: string;
  selected?: boolean;
}> = ({ label, icon, iconBgColor, onClick, borderColor, selected = false }: any) => {
  return (
    <button
      onClick={onClick}
      className={`${styles.filterButton}`}
      style={{
        borderColor: selected ? borderColor : "transparent",
      }}
    >
      <div
        className={styles.filterButtonIcon}
        style={{ backgroundColor: iconBgColor }}
      >
        {icon}
      </div>
      <div>{label}</div>
    </button>
  );
};
export default GroupsFilterButton;
